import React, { useState } from "react";
import QRCode from "react-qr-code";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import getDelphiNumber from "../../../../utils/getDelphiNumber";
import "./style.scss";
import { AiOutlineSafety } from "react-icons/ai";
import format from "date-fns/format";
import CardBalance from "./CardBalance";
import CardDescription from "./CardDescription";
import CardName from "./CardName";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import ModalComponent from "../../../../features/ModalComponent";

import { ECARD_RECHARGE } from "../../../routes";
import { Link } from "react-router-dom";
import LoadingSpinner from "../../../../features/Loading/LoadingSpinner";
import { useTranslation } from "react-i18next";
import EAButton from "../../shared/Buttons/EAButton";
const AccountCardPanel: React.FC = () => {
  const { t } = useTranslation();
  const userData = useSelector((state: State) => state.auth.userData);
  const loading = useSelector((state: State) => state.auth.loading);
  const isDesktop = useDesktopSize();
  const [open, setOpen] = useState(false);
  const ecardQr = useSelector((state: State) => state.config.configuration.ecard_showBarCode);
  const ecardRegisterIncome = useSelector((state: State) => state.config.configuration.ecard_RegisterIncome);

  return (
    <>
      {loading ? (
        <div className="flex-between-center">
          <LoadingSpinner />
        </div>
      ) : (
        <>
          {isDesktop ? (
            <div className="account-card">
              <div className=" account-card-title flex-between-center">
                <h4>{t("moja_karta")}</h4>
                {/* <EAButton title={t("dowiedz_sie_wiecej")} startIcon={<MdOutlineInfo />} variant="text"/> */}
              </div>

              <div className="account-card-box">
                <div className="account-card-up flex-between">
                  <div className="account-card-up-left">
                    <CardName />
                    <div className="flex-start-center">
                      <div className="flex-column">
                        <b>{t("upust")}:</b>
                        <CardDescription />
                      </div>

                      <div className="flex-column">
                        <b>{t("waznosc")}:</b>
                        {userData.closeDate ? (
                          <span>{format(userData.closeDate, "dd.MM.yyyy")}r.</span>
                        ) : (
                          <span>{t("brak")}</span>
                        )}
                      </div>
                    </div>
                  </div>
                  {ecardQr && (
                    <div className="qr flex-center-center flex-column">
                      <QRCode value={`EA_${getDelphiNumber(userData.account)}`} size={100} />
                      <b>{`EA_${getDelphiNumber(userData.account)}`}</b>
                    </div>
                  )}
                </div>

                <div className="account-card-deposit flex-between-center">
                  <div className="">
                    <span>{t("dostepne_srodki")}:</span>
                    <CardBalance />
                  </div>
                  {ecardRegisterIncome && (
                    <Link to={ECARD_RECHARGE}>
                      <EAButton title={t("doladuj_karte")} startIcon={<AiOutlineSafety />} color="secondary" />
                    </Link>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="account-card-mobile account-card-title flex-between-center">
                <h4>{t("moja_karta")}</h4>
                <EAButton title={t("zobacz")} onClick={() => setOpen(!open)} color="secondary" />
              </div>

              {open && (
                <ModalComponent
                  footer={true}
                  open={open}
                  closeModal={() => setOpen(false)}
                  title={t("moja_ekarta")}
                  onAccept={() => setOpen(false)}
                >
                  <div className="account-card">
                    <div className="account-card-box">
                      <div className="account-card-up flex-between">
                        <div className="account-card-up-left">
                          <CardName />
                          <div className="flex-start-center">
                            <div className="flex-column">
                              <b>{t("upust")}:</b>
                              <CardDescription />
                            </div>
                            <div className="flex-column">
                              <b>{t("waznosc")}:</b>
                              {userData.closeDate ? (
                                <span>{format(userData.closeDate, "dd.MM.yyyy")}r.</span>
                              ) : (
                                <span>{t("brak")}</span>
                              )}
                            </div>
                          </div>
                        </div>
                        {ecardQr && (
                          <div className="qr flex-center-center flex-column">
                            <QRCode value={getDelphiNumber(userData.account)} size={100} />
                            <b>{getDelphiNumber(userData.account)}</b>
                          </div>
                        )}
                      </div>
                      <div className="account-card-deposit flex-between-center flex-wrap">
                        <div className="">
                          <span>{t("dostepne_srodki")}:</span>
                          <CardBalance />
                        </div>
                        {ecardRegisterIncome && (
                          <Link to={ECARD_RECHARGE}>
                            <EAButton title={t("doladuj_karte")} startIcon={<AiOutlineSafety />} />
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </ModalComponent>
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default AccountCardPanel;
